export const GRID_TEMPLATES = Object.freeze({
    _: () => '1fr',
    l: (numberOfElements) => numberOfElements >= 3
        ? `repeat(3, 1fr)`
        : `repeat(${numberOfElements}, 1fr)`,
    m: (numberOfElements) => (numberOfElements >= 2 ? `repeat(2, 1fr)` : '1fr'),
    s: () => '1fr',
    xl: (numberOfElements) => numberOfElements >= 4
        ? `repeat(4, 1fr)`
        : `repeat(${numberOfElements}, 1fr)`,
});
export const GAP_PADDING = '24px';
export const GRID_PADDING = '32px';
//# sourceMappingURL=constants.js.map